import { Link, NavLink, useNavigate } from "react-router-dom";
import { menuData } from "./MenuData";
import { useCookies } from "react-cookie";
import { FaSignOutAlt } from "react-icons/fa";
import useIsConnected from "../../utils/IsConnected";
import { useTranslation } from "react-i18next";
import Input from "antd/es/input/Input";
import { Button, Tooltip } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../apis/store";
import { ToSearch } from "../../apis/actions/search.actions";
import { useState } from "react";
import { resetState } from "../../apis/slices/globalSlice";
import { toGetProfil } from "../../apis/actions/auth.actions";
import { toSyncMyCartNow } from "../../apis/actions/cart.actions";
import { confirmAction } from "../../utils/Utils";
interface Props {
  open: boolean;
  setOpen: (v: boolean) => void;
}
const MobileMenu = ({ open, setOpen }: Props) => {
  const [search, setSearch] = useState("");
  const { t, i18n } = useTranslation();
  const [cookies, , removeCookie] = useCookies(["apiKey"]);
  const cookiesToken = cookies.apiKey;
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  return (
    <div
      className={`mobile-header-active mobile-header-wrapper-style perfect-scrollbar button-bg-2 ${
        open && "sidebar-visible"
      }`}
    >
      <div className="mobile-header-wrapper-inner">
        <div className="mobile-header-logo">
          <Link className="d-flex" to="/" onClick={() => setOpen(false)}>
            <img
              className="light-mode"
              alt=""
              src="assets/imgs/template/logo-d.svg"
            />
            <img
              className="dark-mode"
              alt=""
              src="assets/imgs/template/logo-w.svg"
            />
          </Link>
          <div
            className={`burger-icon burger-icon-white ${
              open && "burger-close"
            }`}
            onClick={() => setOpen(false)}
          ></div>
        </div>

        <div className="mobile-header-content-area">
          <Input
            placeholder={t("search.search")}
            onPressEnter={(e) => {
              const value = (e.target as HTMLInputElement).value;
              navigate("/search", {
                state: {
                  name: value,
                },
              });
              dispatch(ToSearch({ name: value, lang: i18n.language }));
            }}
            className="ac-search-input"
            onChange={(e) => {
              setSearch(e.target.value);
            }}
            suffix={
              <Tooltip title={t("search.search-word")}>
                <Button
                  type="text"
                  icon={<SearchOutlined />}
                  onClick={() => {
                    if (search) {
                      navigate("/search", {
                        state: {
                          name: search,
                        },
                      });
                      dispatch(ToSearch({ name: search, lang: i18n.language }));
                      setOpen(false)
                    }
                  }}
                />
              </Tooltip>
            }
          />
          <div className="perfect-scroll">
            <div className="mobile-menu-wrap mobile-header-border">
              <nav>
                <ul className="mobile-menu font-heading ac--font-expo">
                  {cookiesToken
                    ? menuData.map((el) => (
                        <li key={el.key}>
                          <NavLink
                            to={el.link}
                            end={el.link === "/"}
                            onClick={() => setOpen(false)}
                            className={({ isActive }) =>
                              [
                                "ac-nav__link",
                                isActive ? "ac-nav__link--active" : "",
                              ]
                                .filter(Boolean)
                                .join(" ")
                            }
                          >
                            {t(`menu.${el.key}`)}
                          </NavLink>
                        </li>
                      ))
                    : menuData
                        .filter((x) => !x.private)
                        .map((el) => (
                          <li key={el.key}>
                            <NavLink
                              to={el.link}
                              end={el.link === "/"}
                              onClick={() => setOpen(false)}
                              className={({ isActive }) =>
                                [
                                  "ac-nav__link",
                                  isActive ? "ac-nav__link--active" : "",
                                ]
                                  .filter(Boolean)
                                  .join(" ")
                              }
                            >
                              {t(`menu.${el.key}`)}
                            </NavLink>
                          </li>
                        ))}
                  <li>
                    <Link
                      //className="ac--login-btn"
                      to={useIsConnected() ? "/profile" : "/login"}
                    >
                      <svg
                        className="mb-1"
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill={""}
                      >
                        <path
                          d="M1 12C1 12 0 12 0 11C0 10 1 7 6 7C11 7 12 10 12 11C12 12 11 12 11 12H1ZM6 6C6.79565 6 7.55871 5.68393 8.12132 5.12132C8.68393 4.55871 9 3.79565 9 3C9 2.20435 8.68393 1.44129 8.12132 0.87868C7.55871 0.316071 6.79565 0 6 0C5.20435 0 4.44129 0.316071 3.87868 0.87868C3.31607 1.44129 3 2.20435 3 3C3 3.79565 3.31607 4.55871 3.87868 5.12132C4.44129 5.68393 5.20435 6 6 6Z"
                          fill={""}
                        />
                      </svg>
                      <span className={"ac--login-btn ac--menu-black"}>
                        {useIsConnected()
                          ? t("profile.profil")
                          : t("login.enter")}
                      </span>
                    </Link>
                  </li>
                  {cookiesToken ? (
                    <li>
                      <button
                        type="button"
                        className="ac-nav__link ac-nav__mobile-logout ac--font-expo"
                        onClick={async () => {
                          const confirmed = await confirmAction({
                            title: t("profile.logoutConfirm.title"),
                            text: t("profile.logoutConfirm.text"),
                            confirmText: t("profile.logoutConfirm.confirm"),
                            cancelText: t("profile.logoutConfirm.cancel"),
                          });
                          if (!confirmed) return;

                          await dispatch(toSyncMyCartNow());
                          removeCookie("apiKey", { path: "/" });
                          dispatch(resetState());
                          dispatch(toGetProfil(i18n.language));
                          navigate("/");
                          dispatch(resetState());
                          setOpen(false);
                        }}
                      >
                        <FaSignOutAlt
                          className="ac-nav__mobile-logout-icon"
                          size={18}
                          aria-hidden
                        />
                        <span>{t("profile.logout")}</span>
                      </button>
                    </li>
                  ) : null}
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;
